// Apple Sign-In 콜백 처리 훅
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useAppleCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleAppleCallback = async () => {
      try {
        // URL에서 Apple 콜백 파라미터 확인
        const urlParams = new URLSearchParams(location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        const id_token = urlParams.get('id_token');

        // Apple 콜백 파라미터가 있는 경우에만 처리
        if (code && state) {
          console.log('Apple 로그인 콜백 처리 중...');

          // 서버로 코드 전송하여 토큰 교환
          const response = await fetch('/api/auth/apple', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              code,
              id_token,
              state,
            }),
          });

          const data = await response.json();

          if (data.success) {
            // 로그인 성공
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user));
            
            console.log('Apple 로그인 성공');
            
            // URL 파라미터 제거하고 메인 페이지로 이동
            navigate('/', { replace: true });
            
            // 페이지 새로고침으로 인증 상태 반영
            window.location.reload();
          } else {
            throw new Error(data.error || 'Apple 로그인 실패');
          }
        }
      } catch (error) {
        console.error('Apple 콜백 처리 오류:', error);
        
        // 에러 발생시 URL 파라미터 제거
        navigate('/', { replace: true });
        
        // 에러 메시지 표시 (토스트 등)
        alert('Apple 로그인에 실패했습니다. 다시 시도해주세요.');
      }
    };

    // 컴포넌트 마운트시 한 번만 실행
    handleAppleCallback();
  }, [location.search, navigate]); // 필요한 의존성만 포함

  return null;
};

export default useAppleCallback;